document.addEventListener("submit", async (event) => {

    const form = event.target;

    if (!form.matches("product-form form")) return;

    const response = await fetch("/cart.js");
    const cart = await response.json();

    const current = cart.items.reduce(
        (sum, item) => sum + item.quantity,
        0
    );

    const quantity =
        Number(form.querySelector("[name=quantity]")?.value ?? 1);

    if (current + quantity > window.CartLimit.maxItems) {

        event.preventDefault();

        alert(window.CartLimit.message);

    }

});